/* LightSeek page forms (About / Contact) — posts to the Feishu notification API. */
(function () {
  'use strict';

  var DEFAULT_ENDPOINT = 'https://light-seek.com/api/feishu-notify';
  var forms = document.querySelectorAll('[data-ls-form]');
  if (!forms.length) return;

  function collect(form) {
    var payload = {};
    var els = form.querySelectorAll('input[name], textarea[name], select[name]');
    Array.prototype.forEach.call(els, function (el) {
      payload[el.name] = (el.value || '').trim();
    });
    return payload;
  }

  function classesFor(status) {
    var isContact = status.classList.contains('contact-status');
    return {
      ok: isContact ? 'contact-status contact-status-success' : 'form-status success',
      error: isContact ? 'contact-status contact-status-error' : 'form-status error',
      okText: isContact
        ? 'Thank you! Your message has been sent successfully.'
        : 'Thank you! We will get back to you within 24 hours.',
      errorText: isContact
        ? 'Failed to send message. Please try again.'
        : 'Something went wrong. Please try again.'
    };
  }

  /* About page form uses longer "Please enter ..." placeholders on mobile (matches frontend/web). */
  var MOBILE_PLACEHOLDERS = {
    message: 'Please enter  Message Content',
    email: 'Please enter  Your Email',
    name: 'Please enter  Your Name',
    company: 'Please enter  Company Name',
    address: 'Please enter  Company Address'
  };

  Array.prototype.forEach.call(document.querySelectorAll('.about-contact-form'), function (form) {
    var fields = form.querySelectorAll('input, textarea');
    Array.prototype.forEach.call(fields, function (el) {
      el.setAttribute('data-desktop-placeholder', el.placeholder);
    });
    var mq = window.matchMedia('(max-width: 767px)');
    var apply = function () {
      Array.prototype.forEach.call(fields, function (el) {
        if (!MOBILE_PLACEHOLDERS[el.name]) return;
        el.placeholder = mq.matches
          ? MOBILE_PLACEHOLDERS[el.name]
          : el.getAttribute('data-desktop-placeholder');
      });
    };
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  });

  Array.prototype.forEach.call(forms, function (form) {
    var btn = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-ls-form-status]');
    var cls = status ? classesFor(status) : null;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn && btn.disabled) return;

      var endpoint = form.getAttribute('data-endpoint') || DEFAULT_ENDPOINT;
      if (status) status.hidden = true;
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Sending...';
      }

      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(collect(form))
      })
        .then(function () {
          form.reset();
          if (status && cls) {
            status.className = cls.ok;
            status.textContent = cls.okText;
            status.hidden = false;
          }
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Send Message';
          }
        })
        .catch(function () {
          if (status && cls) {
            status.className = cls.error;
            status.textContent = cls.errorText;
            status.hidden = false;
          }
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Send Message';
          }
        });
    });
  });
})();
